var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据日期",
                          },
                        },
                        [
                          _c("j-date", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "operTime",
                                  _vm.validatorRules.operTime,
                                ],
                                expression:
                                  "['operTime', validatorRules.operTime]",
                              },
                            ],
                            attrs: {
                              "show-time": true,
                              disabled: !_vm.rowCanEdit,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据编号",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["number", _vm.validatorRules.number],
                                expression: "['number', validatorRules.number]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: {
                              placeholder: "请输入单据编号",
                              disabled: !_vm.rowCanEdit,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("j-editable-table", {
                ref: _vm.refKeys[0],
                attrs: {
                  loading: _vm.materialTable.loading,
                  columns: _vm.materialTable.columns,
                  dataSource: _vm.materialTable.dataSource,
                  minWidth: 1100,
                  maxHeight: 300,
                  rowNumber: true,
                  rowSelection: _vm.rowCanEdit,
                  actionButton: _vm.rowCanEdit,
                  dragSortAndNumber: _vm.rowCanEdit,
                },
                on: {
                  valueChange: _vm.onValueChange,
                  added: _vm.onAdded,
                  deleted: _vm.onDeleted,
                },
                scopedSlots: _vm._u([
                  {
                    key: "buttonAfter",
                    fn: function () {
                      return [
                        _vm.rowCanEdit
                          ? _c(
                              "a-row",
                              {
                                staticStyle: { float: "left" },
                                attrs: { gutter: 24 },
                              },
                              [
                                _vm.scanStatus
                                  ? _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-button",
                                          { on: { click: _vm.scanEnter } },
                                          [_vm._v("扫码录入")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.scanStatus
                                  ? _c(
                                      "a-col",
                                      {
                                        staticStyle: {
                                          padding: "0 8px 0 12px",
                                        },
                                        attrs: { md: 16, sm: 24 },
                                      },
                                      [
                                        _c("a-input", {
                                          ref: "scanBarCode",
                                          attrs: {
                                            placeholder: "请扫描商品条码并回车",
                                          },
                                          on: {
                                            pressEnter: _vm.scanPressEnter,
                                          },
                                          model: {
                                            value: _vm.scanBarCode,
                                            callback: function ($$v) {
                                              _vm.scanBarCode = $$v
                                            },
                                            expression: "scanBarCode",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.scanStatus
                                  ? _c(
                                      "a-col",
                                      {
                                        staticStyle: {
                                          padding: "0px 12px 0 0",
                                        },
                                        attrs: { md: 6, sm: 24 },
                                      },
                                      [
                                        _c(
                                          "a-button",
                                          { on: { click: _vm.stopScan } },
                                          [_vm._v("收起扫码")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "depotBatchSet",
                    fn: function () {
                      return [
                        _c("a-icon", {
                          attrs: { type: "down" },
                          on: { click: _vm.handleBatchSetDepot },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "a-row",
                {
                  staticClass: "form-row",
                  staticStyle: { "margin-top": "8px" },
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 24, md: 24, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: { xs: { span: 24 }, sm: { span: 24 } },
                            label: "",
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["remark"],
                                expression: "['remark']",
                              },
                            ],
                            attrs: {
                              rows: 1,
                              placeholder: "请输入备注",
                              disabled: !_vm.rowCanEdit,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right", "margin-top": "16px" } },
        [
          _vm.formMode === "view"
            ? _c("a-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("返回"),
              ])
            : [
                _c("a-button", { on: { click: _vm.handleCancel } }, [
                  _vm._v("取消"),
                ]),
                _vm.checkFlag && _vm.isCanCheck
                  ? _c(
                      "a-button",
                      {
                        attrs: { loading: _vm.confirmLoading },
                        on: { click: _vm.handleOkAndCheck },
                      },
                      [_vm._v("保存并审核")]
                    )
                  : _vm._e(),
                !_vm.checkFlag
                  ? _c(
                      "a-button",
                      {
                        attrs: { type: "primary", loading: _vm.confirmLoading },
                        on: {
                          click: function ($event) {
                            return _vm.handleWorkflow()
                          },
                        },
                      },
                      [_vm._v("提交流程")]
                    )
                  : _vm._e(),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary", loading: _vm.confirmLoading },
                    on: { click: _vm.handleOk },
                  },
                  [_vm._v("保存")]
                ),
              ],
        ],
        2
      ),
      _c("depot-modal", {
        ref: "depotModalForm",
        on: { ok: _vm.depotModalFormOk },
      }),
      _c("batch-set-depot", {
        ref: "batchSetDepotModalForm",
        on: { ok: _vm.batchSetDepotModalFormOk },
      }),
      _c("workflow-iframe", {
        ref: "modalWorkflow",
        on: { ok: _vm.workflowModalFormOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }